import { USER_PROFILE, LOGIN } from '_constants';

export const userprofile = (state = {}, action) => {
  let newState = { ...state };
  switch (action.type) {
    case USER_PROFILE.UPDATE_MEMBER:
      newState = { ...newState, ...action.value };
      break;
    case LOGIN.LOGOUT:
      newState = {};
      break;
    default:
      break;
  }
  return newState;
};
